import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { useTenant } from "hooks/settings";
import { useTenantTranslation } from "hooks/formatters";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { ParameterConflict } from "store/api/generatedApi";
import { SaveDefaultsDialog } from "./SaveDefaultsDialog";

export const ReviewFixedMixesButton = ({
  gradeNames,
  hasChanges,
  isSaving,
  isChecking,
  disabled,
  conflicts,
  onSave,
}: {
  gradeNames: string[];
  hasChanges: boolean;
  isSaving: boolean;
  isChecking: boolean;
  disabled: boolean;
  conflicts: ParameterConflict[];
  onSave: (afterSave: () => void) => Promise<void>;
}) => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const navigate = useNavigate();
  const enabled = useIsBehindFeatureFlag("fixed_mix_defaults");
  const [open, setOpen] = useState(false);
  const review = () => {
    const query = new URLSearchParams(
      [...new Set(gradeNames)].map((grade) => ["grade", grade])
    );
    void navigate(`/${tenantName}/parameters/fixed-mixes?${query.toString()}`);
  };
  if (!enabled || gradeNames.length === 0) return null;
  return (
    <>
      <Button
        variant="outlined"
        disabled={disabled || isSaving}
        onClick={() => {
          if (hasChanges) setOpen(true);
          else review();
        }}
      >
        {t(hasChanges ? "saveAndReviewFixedMixes" : "reviewFixedMixes")}
      </Button>
      <SaveDefaultsDialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onConfirm={async () => {
          await onSave(review);
          setOpen(false);
        }}
        isSaving={isSaving}
        isChecking={isChecking}
        disabled={disabled || !hasChanges}
        conflicts={conflicts}
      />
    </>
  );
};
